import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import { PdfReportDisplay } from "@/types/affiliation";
import { ApiResponse } from "@/types/global";
import {
  ExamReportInputs,
  MarksheetReportInputs,
  MonthlySchoolReviewInputs,
  MonthlyStudentProgressReportInputs,
  TestReportInputs,
  TestSeriesReportInputs,
} from "@/types/pdfReport";

export default class PdfReportApi extends ApiVerified {
  async getMonthlySchoolReviewReport(
    reportInputs: MonthlySchoolReviewInputs,
  ): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-monthly-school-review-report`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getMonthlyStudentProgressReports(
    testReportInputs: MonthlyStudentProgressReportInputs,
  ): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-monthly-student-progress-reports`,
        testReportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getSchoolTestReport(reportInputs: TestReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-school-test-report`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getSchoolExamReport(reportInputs: ExamReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-school-exam-report`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getSchoolTestSeriesReport(reportInputs: TestSeriesReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-school-test-series-report`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getStudentTestReports(reportInputs: TestReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-student-test-reports`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getStudentExamReports(reportInputs: ExamReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-student-exam-reports`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getStudentTestSeriesReports(reportInputs: TestSeriesReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-student-test-series-reports`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getStudentMarksheetReports(reportInputs: MarksheetReportInputs): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<PdfReportDisplay>(
        `pdf-report/get-student-marksheet-reports`,
        reportInputs,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async regeneratePdfReport(mongoId: string): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.post<boolean>(
        `pdf-report/regenerate-pdf-report`,
        undefined,
        { params: { mongoId: mongoId } },
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
